/** PRISM Dimensions and Themes table — appended when CMS content lacks a table. */
export const PRISM_TABLE_SECTION_HTML = `
<div class="fs-20 fw-600 mb-2">PRISM Dimensions and Themes</div>
<div class="table-responsive">
  <table class="table">
    <thead class="table-light">
      <tr>
        <th class="bg_pink">Dimensions</th>
        <th class="bg_purple text-white">Social</th>
        <th class="bg_green text-white">Environmental</th>
        <th class="bg_skyBlue text-white">Building Safety</th>
      </tr>
    </thead>
    <tbody>
      <tr class="tr_first">
        <td rowspan="9" style="vertical-align: middle;">Themes</td>
        <td class="bg_puprle_100 custom_padding">Social infrastructure</td>
        <td class="bg_green_100 custom_padding">Integrated water management</td>
        <td class="bg_skyBlue_100 custom_padding">Building maintenance / repair</td>
      </tr>
      <tr>
        <td class="bg_puprle_200 custom_padding"></td>
        <td class="bg_green_200 custom_padding">Industrial wastewater</td>
        <td class="bg_skyBlue_200 custom_padding">Electrical safety</td>
      </tr>
      <tr>
        <td class="bg_puprle_100 custom_padding">Indoor environment</td>
        <td class="bg_green_100 custom_padding">Solid waste management</td>
        <td class="bg_skyBlue_100 custom_padding">Fire safety</td>
      </tr>
      <tr>
        <td class="bg_puprle_200 custom_padding">Worker engagement</td>
        <td class="bg_green_200 custom_padding">Energy management</td>
        <td rowspan="6" class="bg_skyBlue_100 custom_padding"></td>
      </tr>
      <tr>
        <td class="bg_puprle_100 custom_padding">Gender empowerment</td>
        <td class="bg_green_100 custom_padding">Chemicals management</td>
      </tr>
      <tr>
        <td class="bg_puprle_200 custom_padding">General social management and monitoring</td>
        <td class="bg_green_200 custom_padding">Emissions</td>
      </tr>
      <tr>
        <td class="bg_puprle_100 custom_padding"></td>
        <td class="bg_green_100 custom_padding">Climate resilience</td>
      </tr>
      <tr>
        <td class="bg_puprle_100 custom_padding"></td>
        <td class="bg_green_200 custom_padding">Environmental transparency</td>
      </tr>
      <tr>
        <td class="bg_puprle_100 custom_padding"></td>
        <td class="bg_green_100 custom_padding">General environmental management</td>
      </tr>
    </tbody>
  </table>
</div>
`.trim();

/** Default /prism-intro body when CMS is empty or unavailable. */
export const PRISM_INTRO_FALLBACK_HTML = `
<div class="row align-items-center">
  <div class="col-md-7">
    <div class="section_one">
      <h5 class="fs-20 fw-600">Introduction to the Performance &amp; Resilience in Sustainable Manufacturing (PRISM) and its relevance</h5>
      <p>As Textile &amp; Apparel (T&amp;A) industrial level production becomes a more active contributor to developing and emerging trade economies, the sector also faces the challenges that growing industrial sectors often bring. These challenges include increased social and environmental risks through impacts such as pollution, workforce issues, and the relationship with global buyers and investors, who are increasingly enshrining sustainability at the core of their business practices. It is therefore important that effective safeguards are in place to help T&amp;A producers, especially those operating in Industrial Park (IP) settings.</p>
      <p>In this context, IDH's Performance &amp; Resilience in Sustainable Manufacturing (PRISM) program aims to support countries improve the social and environmental performance of their industrial production to address public concerns, meet with global buyer requirements and promote the sustainability of IPs development.</p>
      <p>As part of the PRISM program, IDH has developed the Performance &amp; Resilience in Sustainable Manufacturing (PRISM). The PRISM is a tool that assesses the performance of IPs and T&amp;A factories in a transparent manner. It provides a holistic and comprehensive platform to not only measure their performance, but to also support continuous improvement and transformation.</p>
    </div>
  </div>
  <div class="col-md-5">
    <div class="colored-box position-relative">
      <div class="hover-image">
        <img src="assets/images/ipsa_img.png" class="img-fluid" alt="">
      </div>
    </div>
  </div>
</div>
<div class="section_two">
  <h5 class="fs-20 fw-600">Application of the PRISM</h5>
  <p>The PRISM is for use in Kenya, Ethiopia and Vietnam. It is designed to assess the social and environmental dimensions of IPs and T&amp;A factories that operate within IP settings in the in-scope countries. The PRISM includes a high-level building safety dimension that is focused on the assessment of maintenance aspects that could impact the occupational health and safety of occupants at factory building level.</p>
  <p>The PRISM is applicable to existing IPs and T&amp;A factories. It can also act as a guide in the design phase of a new IP that aspires to operate in line with sustainability principles.</p>
  <p>Results from an PRISM assessment will support discussions, among IP and T&amp;A factory management, towards the development of a roadmap for continuous improvement and transformation.</p>
</div>
<div class="fs-20 fw-600 mb-2">PRISM Dimensions and Themes</div>
<div class="table-responsive">
  <table class="table">
    <thead class="table-light">
      <tr>
        <th class="bg_pink">Dimensions</th>
        <th class="bg_purple text-white">Social</th>
        <th class="bg_green text-white">Environmental</th>
        <th class="bg_skyBlue text-white">Building Safety</th>
      </tr>
    </thead>
    <tbody>
      <tr class="tr_first">
        <td rowspan="9" style="vertical-align: middle;">Themes</td>
        <td class="bg_puprle_100 custom_padding">Social infrastructure</td>
        <td class="bg_green_100 custom_padding">Integrated water management</td>
        <td class="bg_skyBlue_100 custom_padding">Building maintenance / repair</td>
      </tr>
      <tr>
        <td class="bg_puprle_200 custom_padding"></td>
        <td class="bg_green_200 custom_padding">Industrial wastewater</td>
        <td class="bg_skyBlue_200 custom_padding">Electrical safety</td>
      </tr>
      <tr>
        <td class="bg_puprle_100 custom_padding">Indoor environment</td>
        <td class="bg_green_100 custom_padding">Solid waste management</td>
        <td class="bg_skyBlue_100 custom_padding">Fire safety</td>
      </tr>
      <tr>
        <td class="bg_puprle_200 custom_padding">Worker engagement</td>
        <td class="bg_green_200 custom_padding">Energy management</td>
        <td rowspan="6" class="bg_skyBlue_100 custom_padding"></td>
      </tr>
      <tr>
        <td class="bg_puprle_100 custom_padding">Gender empowerment</td>
        <td class="bg_green_100 custom_padding">Chemicals management</td>
      </tr>
      <tr>
        <td class="bg_puprle_200 custom_padding">General social management and monitoring</td>
        <td class="bg_green_200 custom_padding">Emissions</td>
      </tr>
      <tr>
        <td class="bg_puprle_100 custom_padding"></td>
        <td class="bg_green_100 custom_padding">Climate resilience</td>
      </tr>
      <tr>
        <td class="bg_puprle_100 custom_padding"></td>
        <td class="bg_green_200 custom_padding">Environmental transparency</td>
      </tr>
      <tr>
        <td class="bg_puprle_100 custom_padding"></td>
        <td class="bg_green_100 custom_padding">General environmental management</td>
      </tr>
    </tbody>
  </table>
</div>
`.trim();
